import { tenantApiPath } from "../tenantApi";
import { AvosAction } from "../types";
import { GET } from "./actionsTypes";
import { defaultCheck } from "./constants";
import { formatCheck2Backend } from "./util";

const endpoint = (tenantId: string) => tenantApiPath(tenantId, "checks/");

// *set showLoading to false when you just want to refresh the check
// *without showing the loading spinner (and unmounting numerous components)
export function getCheck(tenantId: string, check_id, showLoading = true) {
    return {
        types: [showLoading ? GET.LOADING : `${GET.LOADING}~DoNotShowLoading`, GET.SUCCESS, GET.ERROR],
        payload: {
            request: {
                method: "GET",
                url: `${endpoint(tenantId)}${check_id}/`,
            },
        },
    } as AvosAction;
}

export function triggerCheckBusinessRules(tenantId: string, check_id) {
    return {
        types: [`${GET.LOADING}~DoNotShowLoading`, GET.SUCCESS, GET.ERROR],
        payload: {
            request: {
                method: "GET",
                url: `${endpoint(tenantId)}${check_id}/business-rules`,
            },
        },
    };
}

export function updateCheckState(data) {
    data = formatCheck2Backend(data);
    return {
        type: GET.SUCCESS,
        payload: { data },
    };
}
export function resetCheckState() {
    const data = { ...defaultCheck };
    return {
        type: GET.SUCCESS,
        payload: { data },
    };
}

